





export default {
  name: 'SidebarGroup',
};
